import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, Business } from './index';

export interface BusinessByIdGetParams {
  id: string;
}

export const businessById = (payload: BusinessByIdGetParams): Action<BusinessByIdGetParams> => ({
  type: actions.businessByIdTrigger.toString(),
  payload,
});

export const businessByIdClear = (): Action => ({
  type: actions.businessByIdClear.toString(),
});

export const businessByIdErrorClear = (): Action => ({
  type: actions.businessByIdErrorReset.toString(),
});

export function* businessByIdRequestSaga({ payload }: Action<BusinessByIdGetParams>) {
  yield put({
    type: actions.businessByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.businessByIdError.toString(),
      payload: {
        message: 'BusinessById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/businesses/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Business, Business>(
    response,
    actions.businessByIdSuccess.toString(),
    actions.businessByIdError.toString(),
    false,
    (businessByIdData) => businessByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.businessByIdTrigger.toString(),
    defaultProcessingSaga(
      businessByIdRequestSaga,
      {
        error: actions.businessByIdError.toString(),
        locationCancel: actions.businessByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.businessByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.businessByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.businessByIdErrorReset.toString(),
    });
  });
}
